import { useIntl } from 'react-intl';

import {
  safeFormattedIntlString,
  SafeFormattedMessageWithoutSpread,
} from '@savgroup-front-common/core/formatters';
import { LanguageChooser } from '@savgroup-front-common/core/molecules/LanguageChooser';
import { ReversioIcon } from '@savgroup-front-common/core/protons/icons';
import { cn } from '@savgroup-front-common/primitive/lib/utils';

import {
  ACCEPTED_LANGUAGES,
  HERO_IMAGE_BY_LOCALE,
  REVERSIO_WEBSITE_URL,
} from '../Onboarding.constants';

import messages from './messages';
import OnboardingForm from './OnboardingForm/OnboardingForm';

const OnboardingEntry = ({
  handleUserEmail,
}: {
  handleUserEmail: (userEmail: string) => void;
}) => {
  const { locale } = useIntl();
  const heroImage = HERO_IMAGE_BY_LOCALE[locale];

  return (
    <div className="grid min-h-screen bg-surface-base-default xl:grid-cols-[44%_minmax(0,1fr)]">
      <aside
        className={cn(
          'flex flex-col items-center bg-surface-brand-default px-6 py-7 stext-contrast-default md:px-10',
          'xl:sticky xl:top-0 xl:h-screen xl:overflow-hidden xl:pb-0',
        )}
      >
        <a
          href={REVERSIO_WEBSITE_URL}
          className="self-start"
          aria-label={safeFormattedIntlString(messages.homeLink)}
        >
          <ReversioIcon className="h-6" />
        </a>
        <div className="mt-7 max-w-130 text-center xl:mt-24">
          <p className="mb-4 text-xl leading-tight font-bold tracking-tight md:text-2xl">
            <SafeFormattedMessageWithoutSpread message={messages.imgTitle} />
          </p>
          <p className="text-base leading-normal opacity-90">
            <SafeFormattedMessageWithoutSpread
              message={messages.imgDescription}
            />
          </p>
        </div>
        {heroImage && (
          <img
            src={heroImage}
            alt=""
            className="mt-16 hidden w-full max-w-125 xl:block"
          />
        )}
      </aside>
      <div className="flex min-w-0 flex-col">
        <div className="flex h-16 items-center justify-end px-4 md:px-7">
          <LanguageChooser acceptedLanguages={ACCEPTED_LANGUAGES} />
        </div>
        <main className="mx-auto w-full max-w-190 px-4 pt-2.5 pb-14 md:px-8">
          <h1 className="mb-3.5 text-2xl font-bold tracking-tight stext-base-default">
            <SafeFormattedMessageWithoutSpread message={messages.title} />
          </h1>
          <p className="mb-8 text-base leading-normal stext-muted-default">
            <SafeFormattedMessageWithoutSpread message={messages.lead} />
          </p>
          <OnboardingForm handleUserEmail={handleUserEmail} />
        </main>
      </div>
    </div>
  );
};

OnboardingEntry.displayName = 'OnboardingEntry';

export default OnboardingEntry;
